import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { PassportModule} from './passport/passport.module'
import { AuthModule } from './auth/auth.module';
import { UserModule } from './user/user.module';
import {UserEntity} from './user/user.entity';
import { ScheduleModule } from '@nestjs/schedule';
import { PostModule } from './post/post.module';
import { PostTypeModule } from './post-type/post-type.module';
import { CommentsModule } from './comments/comments.module';
import { ReportModule } from './report/report.module';
import { PostFilesModule } from './post-files/post-files.module';
import { PostVisibilityModule } from './post-visibility/post-visibility.module';
import { PostActivityModule } from './post-activity/post-activity.module';
import { HierarchyModule } from './hierarchy/hierarchy.module';
import { ProfileModule } from './profile/profile.module';
import { RolesModule } from './roles/roles.module';
import { ProfileEntity } from './profile/profile.entity';
import { HierarchyEntity } from './hierarchy/hierarchy.entity';
import { RolesEntity } from './roles/roles.entity';
import { PostEntity } from './post/post.entity';
import { PostTypeEntity } from './post-type/post-type.entity';
import { PostFilesEntity } from './post-files/post-files.entity';
import { PostActivityEntity } from './post-activity/post-activity.entity';
import { CommmentsEntity } from './comments/comments.entity';
import { PostVisibilityEntity } from './post-visibility/post-visibility.entity';
import { ReportEntity } from './report/report.entity';
import { StatesEntity } from './states/states.entity';
import { StatesModule } from './states/states.module';
import { DistrictModule } from './district/district.module';
import { DistrictEntity } from './district/district.entity';
import { MandalModule } from './mandal/mandal.module';
import {MandalEntity} from './mandal/mandal.entity';
import { VillageModule } from './village/village.module';
import {VillageEntity} from './village/village.entity';
import { RoleActivityModule } from './role-activity/role-activity.module';
import { ActivityEntity } from './activity/activity.entity';
import { RoleActivityEntity } from './role-activity/role-activity.entity';
import { ActivityModule } from './activity/activity.module';
import { EventsEntity } from './event/event.entity';
import { EventsModule } from './event/event.module';
import { LivetvEntity } from './livetv/livetv.entity';
import { LivetvModule } from './livetv/livetv.module';
import { PollModule } from './poll/poll.module';
import { EventDetailsModule } from './event-details/event-details.module';
import { EventDetailsEntity } from './event-details/event-details.entity';
import { PollEntity } from './poll/poll.entity';
import { AddsModule } from './adds/adds.module';
import { AddsEntity } from './adds/adds.entity';
import { RepresentationModule } from './representation/representation.module';
import { RepresentationEntity } from './representation/representation.entity';
import { UserOtp } from './user/user-otp.entity';
import { WelfareModule } from './welfare/welfare.module';
import { WelfareEntity } from './welfare/welfare.entity';
import { EventscategoryModule } from './eventcategory/eventcategory.module';
import { EventscategoryEntity } from './eventcategory/eventcategory.entity';
import { WelfaretypeModule } from './welfaretype/welfaretype.module';
import { WelfaretypeEntity } from './welfaretype/welfaretype.entity';
import { PollVotingEntity } from './poll/poll-voting.entity';
import { EventFilesEntity } from './event/event-files.entity';
import { PostPointsEntity } from './post/post-points.entity';
import { WelfareFilesEntity } from './welfare/welfare-files.entity';
import { RepresentationFilesEntity } from './representation/representationfiles.entity';
import { DevelopmentStatusEntity } from './developmentpost/developmentpost.entity';
import { DevelopmentstatusModule } from './developmentpost/development.module';
import { WelfareStatusEntity } from './welfare/welfare-status.entity';
import { PostActivitySharedEntity } from './post-activity/Post_activityshared.entity';
import { UserPointsEntity } from './post/user-points.entity';
import { EventRSVPEntity } from './event/event-rsvp.entity';
import { NotificationsModule } from './notifications/notifications.module';
import { NotificationsEntity } from './notifications/notifications.entity';
import { FeedBackEntity } from './feedback/feedback.entity';
import { FeedbackModule } from './feedback/feedback.module';
import { BloodGroupModule } from './bloodgroup/blood-group.module';
import { BloodGroupEntity } from './bloodgroup/blood-group.entity';
import { IdeaModule } from './idea/idea.module';
import { IdeaEntity } from './idea/idea.entity';
import { IdeaFilesEntity } from './idea/ideafiles.entity';
import { ComplaintEntity } from './complaint/complaint.entity';
import { ComplaintTypeEntity } from './complaint/complaint-type.entity';
import { ComplaintFilesEntity } from './complaint/complaint-files.entity';
import { ComplaintStatusEntity } from './complaint/status-details.entity';
import { ComplaintModule } from './complaint/complaint.module';
import { IdeaActivityEntity } from './idea/idea-activity.entity';
import { YoutubeEntity } from './youtube/youtube.entity';
import { YoutubeModule } from './youtube/youtube.module';
import { LinkTypesEntity } from './youtube/link-types.entity';
import { ChayuthaEntity } from './kchayutha/kchayutha.entity';
import { ChayuthaModule } from './kchayutha/kchayutha.module';
import { CMRFEntity } from './cmrf/cmrf.entity';
import { CMRFModule } from './cmrf/cmrf.module';

@Module({
  imports: [    
    TypeOrmModule.forRoot({
    type: 'mysql',
    //host: 'localhost',
    host: '128.199.19.83',
		port: 3306,
    username: 'root',
    //password:'admin@123',
		password: 'Sriv@1990',
    database: 'netr_kur',  //netr_dev
    entities: [UserOtp,StatesEntity,DistrictEntity,MandalEntity,VillageEntity,UserEntity,ProfileEntity,HierarchyEntity,RolesEntity,ActivityEntity,RoleActivityEntity,PostEntity,PostTypeEntity,PostFilesEntity,PostActivityEntity,CommmentsEntity,PostVisibilityEntity,ReportEntity,EventsEntity,EventFilesEntity,EventDetailsEntity,LivetvEntity,PollEntity,AddsEntity,RepresentationEntity,WelfareEntity,EventscategoryEntity,WelfaretypeEntity,WelfareStatusEntity,PollVotingEntity,WelfareFilesEntity,RepresentationFilesEntity,DevelopmentStatusEntity,PostPointsEntity,PostActivitySharedEntity,UserPointsEntity,EventRSVPEntity,NotificationsEntity,FeedBackEntity,BloodGroupEntity,IdeaEntity,IdeaFilesEntity,ComplaintEntity,ComplaintTypeEntity,ComplaintFilesEntity,ComplaintStatusEntity,IdeaActivityEntity,YoutubeEntity,LinkTypesEntity,ChayuthaEntity,CMRFEntity],
    synchronize: false,
    logging: false
  }), 
  ScheduleModule.forRoot(),
  AuthModule, UserModule,StatesModule,DistrictModule,VillageModule,MandalModule,PassportModule, PostModule, PostTypeModule, CommentsModule, ReportModule, PostFilesModule, PostVisibilityModule, PostActivityModule, HierarchyModule, ProfileModule, RolesModule, ActivityModule,DistrictModule, MandalModule, VillageModule, RoleActivityModule,EventsModule,LivetvModule, PollModule, EventDetailsModule, AddsModule, RepresentationModule,WelfareModule,EventscategoryModule,WelfaretypeModule,DevelopmentstatusModule,NotificationsModule,FeedbackModule,BloodGroupModule,IdeaModule,ComplaintModule,YoutubeModule,ChayuthaModule,CMRFModule],
  controllers: [AppController, ],
  providers: [AppService, ],
})
export class AppModule {}
